export default {
  teaching: [
    // 时间，课程，学校
    '2008-2009,Math 2110: Differential Equations,HKBU',
    '2008-2009,Math 3680: Functional Analysis,HKBU',
    '2009-2010,Math 0022: Foundation of Mathematics I (Science),HKBU,with Dr. Qiao Zhonghua',
    '2009-2010,Math 3680: Functional Analysis,HKBU',
    '2010-2011,MATH 2150: Mathematical Analysis III,HKBU',
    '2010-2011,MATH 3760: Abstract Algebra,HKBU',
    '2011-2012,MATH 2150: Mathematical Analysis III,HKBU',
    '2012-2013,MATH 2150: Mathematical Analysis III,HKBU',
    '2012-2013,SCI 3530: Numerical Methods for PDE,HKBU,with Prof. Tang Tao',
    '2012-2013,MATH 3620: Numerical Methods II,HKBU',
    '2013-2014,SCI 3530: Numerical Methods for PDE,HKBU',
    '2013-2014,MATH 3680: Functional Analysis,HKBU',
    '2013-2014,MFFM7010: Topics in Probability Theory and Stochastic Processes,HKBU',
    '2014-2015,SCI 3530/MATH3616: Numerical Methods for PDE,HKBU',
    '2014-2015,MATH 3407: Advanced Linear Algebra,HKBU',
    '2015-2016,MATH1006: Advanced Calculus I,HKBU,',
    '2015-2016,MATH1006: Advanced Calculus I,HKBU',
    '2015-2016,MATH3615/SCI3710: Introduction to Imaging Science,HKBU',
    '2016-2017,MATH1006: Advanced Calculus I,HKBU',
    '2016-2017,MATH2217: Advanced Calculus II,HKBU',
    '2016-2017,MATH1006: Advanced Calculus I,HKBU ',
    '2017-2018,MATH3230B: Numerical Analysis,CUHK',
    '2017-2018,MATH4230: Optimization Theory,CUHK',
    '2018-2019,MMAT5340: Probability and Stochastic Analysis,CUHK',
    '2018-2019,MATH3320: Foundation of Data Analytics,CUHK',
    '2018-2019,MATH4230: Optimization Theory,CUHK',
    '2019-2020,MATH3320: Foundation of Data Analytics,CUHK',
    '2019-2020,MATH6211: Topics in Applied Mathematics I,CUHK',
    '2019-2020,MATH4230: Optimization Theory,CUHK',
    '2020-2021,MATH3320: Foundation of Data Analytics,CUHK',
    '2020-2021,MATH6211: Topics in Applied Mathematics I,CUHK',
    '2020-2021,MATH4230: Optimization Theory,CUHK'
  ],
  postdocs: [
    { id: 1, name: 'Dr. Ruyi Feng', duration: '2021-' },
    { id: 2, name: 'Dr. Yingying Fang', duration: '2021-' },
    { id: 3, name: 'Dr. Qianting Ma', duration: '2020-' },
    { id: 4, name: 'Dr. Haiyong Liao', duration: '2010', current: 'Associate Professor, Department of Computer Science, Shantou University, China' },
    { id: 5, name: 'Dr. Huibin Chang', duration: '2012-2013', current: 'Associate Professor, School of Mathematical Sciences, Tianjin Normal University, China' },
    { id: 6, name: 'Dr. Xu Guo', duration: '2018-2019', current: 'Associate Professor, Shandong University, China' },
    { id: 7, name: 'Dr. Hongfei Yang', duration: '2018-', current: 'co-supervised with Prof. Raymond Chan' }
  ],
  postgraduate: [
    { id: 1, name: '' }
  ]
}
